module.exports = __webpack_public_path__ + "static/media/iStock-1253641776.d88e87b2.jpg";